// Media Slider
const initSlider = (target = null, param = {}) => {
	if (target === null) {
		return;
	}

	const args = Object.assign({
		// breakpoints: {
		// 	769: { slidesPerView: 1 }
		// },
		loop: true,
		pagination: {
			el: target.querySelector('.pagination'),
			clickable: true
		},
		slideClass: 'slide',
		slidesPerView: 1,
		spaceBetween: 40,
		wrapperClass: 'wrapper',
	}, param);

	target.__swiper = new Swiper(target.querySelector('.container'), args);
};

window.addEventListener('DOMContentLoaded', () => {
	// Header Height
	{
		const setHeight = () => {
			const section = document.querySelector('#shopify-section-header');
			const header = section.querySelector('.site-header');
			const height = header.classList.contains('site-header--stuck') ? header.clientHeight : section.clientHeight;
			section.style.cssText = `--header-height: ${height}px`;
		}

		setHeight();
		window.addEventListener('resize', setHeight);
		window.addEventListener('scroll', setHeight);
	};

	// Header Megamenu Hover Action(PC)
	{
		const background = document.querySelector('#megamenu-background');
		for (navi of document.querySelectorAll('.site-nav--has-dropdown')) {
			navi.addEventListener('mouseover', () => background.classList.add('focused'));
			navi.addEventListener('mouseout', () => background.classList.remove('focused'));
		}
	};

	// Header Drawer
	{
		const footer = document.querySelector('#shopify-section-footer [data-type="custom"]').cloneNode(true);
		for (const defs of footer.querySelectorAll('defs')) {
			defs.remove();
		}
		document.querySelector('#NavDrawer #footer-menu-moved').append(footer);
	};

	// Accordion
	{
		const accordions = document.querySelectorAll('[data-trigger="accordion"]');
		const resetHeight = async e => {

			e.style.cssText = `--accordion-height: ${e.querySelector('dd').scrollHeight + 5}px;`;
			e.classList.add('is-accordion');

		}
		for (const accordion of accordions) {
			resetHeight(accordion);
			window.addEventListener('resize', () => resetHeight(accordion));

			accordion.querySelector('dt').addEventListener('click', () => {
				accordion.classList.toggle('is-open');
			});
		}
	};

	// Product last section
	{
		const sections = document.querySelectorAll('.products-section');
		const filting = [...sections].filter(e => {
			const style = e.querySelector('style');
			if (style !== null && style.innerHTML.includes('display: none !important;')) {
				return false;
			}

			return true;
		});

		if (filting.length > 0) {
			filting[0].classList.add('first-section');
			filting.slice(-1)[0].classList.add('last-section');
		}
	};

	// Tooltip
	{
		const selectors = document.querySelectorAll('.wovn-languages');
		for (const selector of selectors) {
			for (const trigger of selector.querySelectorAll('.wovn-switch')) {
				trigger.addEventListener('click', () => {
					selector.querySelector('input').checked = false;
				});

				new MutationObserver(() => {
					if (trigger.classList.contains('selected')) {
						selector.querySelector('label span').innerHTML = trigger.innerHTML;
					}
				}).observe(trigger, { attributes: true });
			}
		}
	};

	// In a policies directory
	{
		const dir = location.pathname;
		if (dir.includes('/policies/')) {
			document.body.classList.add('template-page');

			const title = document.querySelector('.shopify-policy__title');
			document.querySelector('.shopify-policy__container').before(title);

			;; (async () => {
				const breadcrumb = await (await fetch('/collections/all?sections=ci-breadcrumb')).json();
				const buffer = Object.assign(document.createElement('div'), { innerHTML: breadcrumb['ci-breadcrumb'] });
				[...buffer.querySelectorAll('li span')].slice(-1)[0].innerHTML = title.innerText;
				document.querySelector('.main-content').prepend(buffer);
			})();
		}
	};

	// Smooth scroll
	{
		const smooth = e => {
			if (e === null) return;

			const header = document.querySelector('#SiteHeader');
			const getPosition = () => e.getBoundingClientRect().top + window.pageYOffset - header.offsetHeight - 20;
			const top = getPosition();

			new Promise(resolve => resolve())
			.then(() => window.scrollTo({ top, behavior: 'smooth' }))
			.then(setTimeout(() => {
				const diff = getPosition();
				window.scrollTo({ top: diff, behavior: 'smooth' });
			}, 600));
		};

		window.addEventListener('load', () => {
			if (location.hash !== '') {
				smooth(document.querySelector(location.hash));
			}
			
			for (const a of document.querySelectorAll('a[href^="#"]')) {
				const href = a.getAttribute('href');
				if (href.length === 1) continue;

				a.addEventListener('click', e => {
					e.preventDefault();
					smooth(document.querySelector(href));
				})
			}
		})
	};

	// Form
	{
		for (const form of document.querySelectorAll('form')) {
			const submit = form.querySelector('.viewmore a') ?? form.querySelector('button[type="submit"]');
			const requires = form.querySelectorAll('.require');
			if (submit === null || requires.length === 0) {
				continue;
			}

			submit.addEventListener('click', e => {
				e.preventDefault();

				const err = [];

				for (const require of requires) {
					const label = require.querySelector('label');
					const component = require.querySelector('input:not(hidden)')
						?? require.querySelector('textarea')
						?? require.querySelector('select');
					if (component === null) {
						continue;
					}

					component.setErr = str => {
						component.classList.add('error');
						err.push(str);
					};

					component.classList.remove('error');

					if (component.name.includes('name')) {
						const inputs = require.querySelectorAll('input');
						if (inputs.length > 1) {
							let boolean = false;
							for (const input of inputs) {
								input.classList.remove('error');
								if (input.value === '') {
									boolean = true;
									input.classList.add('error');
								}
							}
							if (boolean === true) {
								err.push(`${label.innerText}が入力されていません。`);
							}
							continue;
						}

						if (component.value === '') {
							component.setErr(`${label.innerText}が入力されていません。`);
							continue;
						}
					}

					if (component.name.includes('kana')) {
						const inputs = require.querySelectorAll('input');
						if (inputs.length > 1) {
							let boolean = false;
							for (const input of inputs) {
								input.classList.remove('error');
								if (input.value === '') {
									boolean = 'null';
									input.classList.add('error');
								}
								if (!input.value.match(/^[ァ-ヶー　]*$/)) {
									boolean = 'kana';
									input.classList.add('error');
								}
							}
							if (boolean === 'null') {
								err.push(`${label.innerText}が入力されていません。`);
							}
							if (boolean === 'kana') {
								err.push(`${label.innerText}が不正な形式です。`);
							}
							continue;
						}

						if (component.value === '') {
							component.setErr(`${label.innerText}が入力されていません。`);
							continue;
						}
					}

					if (component.type === 'password' && component.value === '') {
						component.setErr(`${label.innerText}が入力されていません。`);
						continue;
					}

					if (component.type === 'email') {
						if (component.value === '') {
							component.setErr(`${label.innerText}が入力されていません。`);
							continue;
						}
						// if (!component.value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
						// 	component.setErr(`${label.innerText}が不正な形式です。`);
						// 	continue;
						// }
					}

					if (component.name.includes('zip') && component.value === '') {
						component.setErr(`${label.innerText}が入力されていません。`);
						continue;
					}

					if (component.name.includes('city') && component.value === '') {
						component.setErr(`${label.innerText}が入力されていません。`);
						continue;
					}

					if (component.name.includes('address1') && component.value === '') {
						component.setErr(`${label.innerText}が入力されていません。`);
						continue;
					}

					if (component.name.includes('address2') && component.value === '') {
						component.setErr(`${label.innerText}が入力されていません。`);
						continue;
					}

					if (component.type === 'tel' && component.value === '') {
						component.setErr(`${label.innerText}が入力されていません。`);
						continue;
					}

					if (component.nodeName === 'TEXTAREA' && (component.value === '' || component.value.length === 0)) {
						component.setErr(`${label.innerText}が入力されていません。`);
					}

					if (component.nodeName === 'SELECT' && component.value === '') {
						component.setErr(`${label.innerText}が入力されていません。`);
					}
				}

				if (err.length > 0) {
					alert(err.join('\n'));

					const header = document.querySelector('#SiteHeader');
					const error = form.querySelector('.error');
					const parent = error.closest('.require');
					const top = parent.getBoundingClientRect().top + (window.pageYOffset - header.offsetHeight - 20);
					window.scrollTo({ top, behavior: 'smooth' });

					return;
				}

				if (submit.tagName === 'BUTTON') {
					form.submit();
				} else {
					location.href = submit.href;
				}
			});
		}
	};

	// Register
	{
		const param = { childList: true, subtree: true };
		for (const form of document.querySelectorAll('#cf-app-customer-fields')) {
			const observer = new MutationObserver(() => {
				observer.disconnect();

				const submit = form.querySelector('.form-submit');
				if (submit !== null) {
					submit.className = '';
					submit.parentNode.classList.add('viewmore');
				}

				for (const required of form.querySelectorAll('.cf-required')) {
					required.innerText = '必須';
				}

				observer.observe(form, param);
			});
			observer.observe(form, param);
		}
	};
});